import React from 'react';
import PropTypes from 'prop-types';

import SelectBox from '../atoms/form/SelectBox';
import { createCheckinOptions, createQuestionOptions } from '../../utils/search';
import { ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';
import Radio from '../atoms/form/Radio';

const ItinerarySchedule = ({
  finalConfirm, plan, SP, hideCheckin, hideMessage,
  handleUpdateCheckin, showQuestions, handleUpdateQuestion,
  previousIsPlanOption,
}) => {
  if (!plan) {
    return (
      <React.Fragment>
      <div className="itinerary">
        <div className="itineraryTitle">宿泊</div>
        <div className="notSelected">{ENABLE_MULTIPLE_HOTEL_PLAN ? '必要な場合、宿泊プランを変更してください' : 'ご宿泊に関しては、お客様ご自身で別途手配が必要となります'}</div>
      </div>
      {!previousIsPlanOption && (
        <div className="mt-15 itineraryCaution">※当社の手配による旅行サービスが一切行われない日(無手配日)は、特別補償の対象外となります。</div>
      )}
      </React.Fragment>
    );
  }

  const {
    name: planName,
    hotel,
    hotelName: sessionPlanHotelName,
    hotelMessage: sessionPlanHotelMessage,
    checkinInfo,
    checkin,
    questions,
  }= plan;

  const finalConfirmPC = !SP && finalConfirm;

  if (finalConfirmPC) {
    return (
      <div className="itinerary">
        <div className="itineraryTitle">宿泊</div>
        <div className="tableItinerarySchedule">
          <div className="title">{sessionPlanHotelName}</div>
          <div className="subTitle">{planName}</div>
          {sessionPlanHotelMessage && !hideMessage && (
            <div className="warningText mt-15" style={{ maxWidth: 350 }}>
              <div className="warningTextTitle">施設に関するご案内・ご注意</div>
              <p dangerouslySetInnerHTML={{ __html: sessionPlanHotelMessage }}/>
            </div>
          )}
        </div>
      </div>
    );
  }

  const hotelName = hotel ? hotel.name : sessionPlanHotelName;

  const checkinOptions = checkinInfo ? createCheckinOptions(checkinInfo.start, checkinInfo.close) : [];

  return (
    <React.Fragment>
      <div className={(!SP || finalConfirm) ? 'itinerary' : ''}>
        {!SP && (
          <div className="itineraryTitle">宿泊</div>
        )}
        <div className={!SP ? 'itineraryScheduleContainer' : 'UserInfoItineraryScheduleContainer'}>
          <div className="title">{hotelName}</div>
          <div className="subTitle">{planName}</div>
          <div className="mealItems">
            <div className="mealItem">
              {plan && plan.mealCondition}
            </div>
            {/* <div className="mealItem">
              夕食
              <span className="blue">TODO あり</span>
            </div>
            <div className="mealItem">
              朝食
              <span className="red">TODO なし</span>
            </div> */}
          </div>
          {!hideCheckin && (
            <div className="checkinItems">
              <div className="checkinItem">
                <span className="checkinText">チェックイン時間</span>
                {!finalConfirm ? (
                  <SelectBox
                    onChange={(e) => handleUpdateCheckin(e.target.value)}
                    value={checkin}
                    options={checkinOptions}
                  />
                ) : (
                  <div>{checkin}</div>
                )}
              </div>
              {false && finalConfirm && (
                <div className="checkinItem">
                  <span className="checkinText">朝食時間</span>
                  <div>TODO 10:00</div>
                </div>
              )}
            </div>
          )}
          {showQuestions && questions && questions.length ? questions.map((q, i) => {
            const { info, selections, title , selected } = q;
            const options = createQuestionOptions(selections);
            return !finalConfirm ? (
              <div key={i} style={{ marginTop: 10 }}>
                {info && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `※ ${info.replace(/\\\\n/g, '<br />').replace(/\n/g, '<br />')}`
                    }}
                  />
                )}
                <div className="questionContent">
                  <div className="questionTitle">
                    <p>{title}</p>
                  </div>
                  <div className="questionRadio">
                    <Radio
                      options={options}
                      id={`question-${planName}-${i}`}
                      value={selected.text}
                      onChange={(value) => {
                        const selected = selections.find((s) => value === s.text);
                        handleUpdateQuestion(title, selected);
                      }}
                      vertical
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="checkinItems">
                <div className="checkinItem">
                  <span style={{ paddingRight: 14 }}>{`${title} :`}</span>
                  <div>{q.selectionText}</div>
                </div>
              </div>
            );
          }) : null}
        </div>
      </div>
      {hotel && hotel.message && !SP && !hideMessage && (
        <div className="warningText mt-15">
          <div className="warningTextTitle">施設に関するご案内・ご注意</div>
          <p dangerouslySetInnerHTML={{ __html: hotel.message }} />
        </div>
      )}
      {sessionPlanHotelMessage && !hideMessage && (
        <div className="warningText mt-15 sessionHotelMessage">
          <div className="warningTextTitle">施設に関するご案内・ご注意</div>
          <p dangerouslySetInnerHTML={{ __html: sessionPlanHotelMessage }}/>
        </div>
      )}
    </React.Fragment>
  );
};

ItinerarySchedule.defaultProps = {
  finalConfirm: false,
  SP: false,
  previousIsPlanOption: false,
};

ItinerarySchedule.propTypes = {
  finalConfirm: PropTypes.bool,
  plan: PropTypes.object,
  SP: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  hideMessage: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  previousIsPlanOption: PropTypes.bool,
};

export default ItinerarySchedule;
